const initialState = {
  pizzaMoneyCsvResponse: [],
  pizzaMoney: [],
  lastDocument: "",
  hasMoreDocument: true,
};

const pizzaMoneyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "PIZZA_MONEY_RESPONSE":
      return {
        ...state,
        pizzaMoneyCsvResponse: action.payload,
      };
      case "PIZZA_MONEY_DATA":
        return {
          ...state,
          pizzaMoney: action.payload.data,
          lastDocument: action.payload.lastDocument,
          hasMoreDocument: action.payload.hasMoreDocument,
        };
      case "MORE_PIZZA_MONEY_DATA":
        return {
          ...state,
          pizzaMoney: [
            ...state.pizzaMoney,
            ...action.payload.data,
          ],
          lastDocument: action.payload.lastDocument,
          hasMoreDocument: action.payload.hasMoreDocument,
        };
    default:
      return {
        ...state,
      };
  }
};

export default pizzaMoneyReducer;
